import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const LinkText = styled.a`
    color: ${colorsPalettes.blue[400]};

    &:hover {
        color: ${colorsPalettes.blue[400]};
    }
`;
